import type { PropertyGroupResponse } from '@/shared/api';

export type RulesLang = 'De' | 'En';
export type RulesDraft = Record<RulesLang, string>;

export const RULES_LANGUAGE: Record<RulesLang, string> = { De: 'Deutsch', En: 'Englisch' };
export const RULES_MAX = 4000;

export const savedRules = (group: PropertyGroupResponse): RulesDraft => ({
  De: group.houseRulesDe ?? '',
  En: group.houseRulesEn ?? '',
});

// Wie der Server: nur Leerzeichen heißt „keine Hausordnung“.
const same = (a: string, b: string) => a.trim() === b.trim();

export const changedLanguages = (draft: RulesDraft, saved: RulesDraft) =>
  (['De', 'En'] as const).filter((lang) => !same(draft[lang], saved[lang]));

/** „Deutsch geändert · Englisch leer“ — was die Leiste über den Entwurf sagt. */
export function rulesSummary(draft: RulesDraft, saved: RulesDraft) {
  const parts = changedLanguages(draft, saved).map((lang) => `${RULES_LANGUAGE[lang]} geändert`);
  for (const lang of ['De', 'En'] as const) {
    if (!draft[lang].trim()) parts.push(`${RULES_LANGUAGE[lang]} leer`);
  }
  return parts.join(' · ');
}

/** Wie das Gastportal wählt: die Sprache des Gasts, sonst die andere Fassung. */
export function guestRules(draft: RulesDraft, lang: RulesLang) {
  const preferred = draft[lang].trim();
  if (preferred) return { text: draft[lang], fallback: false };
  const other = draft[lang === 'De' ? 'En' : 'De'];
  return { text: other.trim() ? other : '', fallback: !!other.trim() };
}
